import { fmtDuracion, type KpisDia as Kpis } from '@/lib/llamadas/presentacion';
import { Icono } from '../Layout/iconos';

// Fila de KPIs del día (prototipo iter5), calculados en cliente desde el feed
// ya cargado. 4 tarjetas en v1: el KPI "fuera de horario" queda pospuesto
// (regla de horario sin definir, spec §9).

function Tarjeta({
  icono,
  etiqueta,
  children,
  pie,
}: {
  icono: string;
  etiqueta: string;
  children: React.ReactNode;
  pie?: React.ReactNode;
}) {
  return (
    <div className="min-w-0 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--surface)] px-4 py-[15px] shadow-[var(--shadow-soft)]">
      <div className="mb-[11px] flex min-h-[30px] items-start gap-2 text-[var(--text-dim)]">
        <Icono nombre={icono} className="mt-px h-[15px] w-[15px] shrink-0" />
        <span className="text-[11.5px] font-medium leading-tight">{etiqueta}</span>
      </div>
      <div className="mono text-[28px] font-semibold leading-none tracking-[-0.6px] text-[var(--navy)]">
        {children}
      </div>
      {pie && <div className="mt-2 text-[11.5px] text-[var(--text-dim)]">{pie}</div>}
    </div>
  );
}

export function KpisDia({ kpis }: { kpis: Kpis }) {
  return (
    <section className="mb-[18px] grid grid-cols-2 gap-[13px] xl:grid-cols-4">
      <Tarjeta icono="phone" etiqueta="Llamadas" pie="atendidas en el día">
        {kpis.total}
      </Tarjeta>
      <Tarjeta
        icono="check"
        etiqueta="Resueltas por IA"
        pie={
          <span className="block h-1 overflow-hidden rounded-full bg-[var(--surface-3)]">
            <span
              className="block h-full rounded-full bg-[var(--status-ok)]"
              style={{ width: `${kpis.resueltasPct ?? 0}%` }}
            />
          </span>
        }
      >
        {kpis.resueltasPct === null ? '—' : <>{kpis.resueltasPct}%</>}
      </Tarjeta>
      <Tarjeta icono="escalate" etiqueta="Escaladas" pie="a operaciones · comercial">
        {kpis.escaladas}
      </Tarjeta>
      <Tarjeta icono="clock" etiqueta="Tiempo medio" pie="por llamada">
        {fmtDuracion(kpis.duracionMediaS)}
      </Tarjeta>
    </section>
  );
}
